<template>
  <v-dialog
    v-model="dialog"
    max-width="1000"
    :style="{ zIndex: options.zIndex }"
    height="800"
    scrollable
    @keydown.esc="cancel"
  >
    <v-card flat style="min-height: 600px;">
      <v-card-title class="pa-0 border-bottom">
        <v-toolbar flat>
          <v-toolbar-title>
            Verknüpfte Umfrage
          </v-toolbar-title>
          <v-spacer/>
          <IconTooltipButtonBottom
            icon="mdi-close"
            tooltip="Schließen"
            @click="cancel"
          />
        </v-toolbar>
      </v-card-title>
      <PXSurveyEvaluationPage :survey-id-prop="connectedSurveyId" />
    </v-card>
  </v-dialog>
</template>

<script>
import surveyService from "@/pages/PxQuestionSurvey/PXSurveyPage/px-survey-service"
import PXSurveyEvaluationPage from "@/pages/PxQuestionSurvey/PXSurveyPage/Evaluation/PXSurveyEvaluationPage.vue"
import IconTooltipButtonBottom from "../../components/common/IconTooltipButtonBottom.vue";
import {decodeModuleNameByNumber} from '@/components/util.js'
export default {
    name: "ConnectedSurveyEval",
    data() {
        return {
            dialog: false,
            resolve: null,
            reject: null,
            title: null,
            options: {
                width: 600,
                zIndex: 200,
            },
            connectedSurveyId: -1,
            surveys: [],
            module: -1,
            moduleText: {
              1: decodeModuleNameByNumber(1),
              2: decodeModuleNameByNumber(2)
            },
            infoText: "Für die Checklistenfunktion muss eine Umfrage aus dem Bindungsmodul verknüpft sein. Sie müssen eine Umfrage verknüpfen, um den ersten Schritt abschließen zu können."
        };
    },
    methods: {
        open(surveyId) {
          this.dialog = true;
          this.connectedSurveyId = surveyId;

            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        cancel() {
            this.connectedSurveyId = -1;
            this.reject(false);
            this.dialog = false;
        },
    },
    components: { PXSurveyEvaluationPage, IconTooltipButtonBottom }
};
</script>
<style scoped lang="less">
:deep .v-app-bar {
  display: none;
}
:deep .v-dialog {
  overflow-y: auto;
  position: relative;
}
:deep .v-sheet.v-card {
  border-radius: unset;
}
:deep .px-layout {
  height: unset;
}
:deep .px-layout > div {
  padding: 4px 20px !important;
}
:deep .survey-title {
  h1 {
    display: none;
  }
  h2 {
    display: block;
    font-family: 'Raleway', sans-serif;
    margin-top: 36px;
  }
}
:deep .evaluation-info {
  transform: scale(0.9);
}
:deep .side-panel {
  top: 0;
  height: 100vh;
}

:deep .v-tab {
  font-size: 1.5vmin;
}

.v-card__title {
  //position: fixed;
  position: sticky;
  top: 0;
  z-index: 999;
}

:deep #cardTitle h3 {
  font-size: 1.5vmin;
  white-space: nowrap;

}
:deep .statistic__main__right {
  transform: scale(0.75);
  margin-left: -14%;
}

:deep .tree-menu__container {
  margin: 14px 52px 52px 20px;
  width: calc(1000px - 40px);
}

:deep #apexcharts31kzzh6b {
  transform: scale(0.9);
  left: -40px;
}

</style>